import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import Header from "./layouts/Header";
import MobileMenu from "./layouts/MobileMenu";

const Layout = () => {
    const location = useLocation();
    const hideHeaderRoutes = ["/login", '/signup'].includes(location.pathname); // Routes where the header should be hidden
    return (
        <main>
            {!hideHeaderRoutes && <Header />}
            <Outlet />
            {!hideHeaderRoutes &&
                <div className='mobile-only'>
                    <MobileMenu />
                </div>}
        </main>
    );
};

export default Layout;
